
import PersonalityButton from '@/components/common/PersonalityButton.vue'
import ShareButton from '@/components/common/ShareButton.vue'
import ExpirePs from '@/components/ExpirePs.vue'
import config from '@/config'
import { defineComponent, onMounted, reactive, ref } from 'vue'
import { useRoute } from 'vue-router'
import Layout from './Layout.vue'
import Clipboard from 'clipboard'
import RedpackInfo from '@/components/RedpackInfo.vue'
import Toast from '@/components/common/Toast.vue'
import { useI18n } from 'vue-i18n'
import hexRgb from 'hex-rgb'

export default defineComponent({
  components: { Layout, PersonalityButton, ExpirePs, ShareButton, RedpackInfo, Toast },
  setup () {
    const route = useRoute()

    const { t } = useI18n()

    const toast = reactive({
      msg: ''
    })

    const query = route.query as {
      chainId: string;
      redPackId: string;
      chainIdInit: string;
      skin: 'a' | 'b'
    }

    const themeColor = config.themeColor[query.skin || process.env.VUE_APP_SKIN_IMAGE]

    function routeToFxRedpack () {
      const link = `fx://redpacket?url=${location.origin}${process.env.VUE_APP_BASEURL}/receive${location.search}`

      location.href = link
    }

    const openWait = ref(false)
    const openFailTips = ref(false)

    function routeToDownloadLink () {
      location.href = 'https://download.functionx.io/beta/'
    }

    function routeToDownload () {
      routeToFxRedpack()

      openWait.value = true

      setTimeout(() => {
        openFailTips.value = true
      }, 3000)
    }

    const shareButtonRef = ref()

    function copyHandler () {
      const copy = new Clipboard('.out-copy-btn', {
        text: () => location.href
      })

      copy.on('success', e => {
        toast.msg = ''
        toast.msg = t('v1.0.copySuccess')
      })
    }

    const bg = hexRgb(themeColor.color, { alpha: 0.88, format: 'css' })

    onMounted(async () => {
      const themeColorMeta = document.querySelector('meta[name="theme-color"]')

      if (themeColorMeta) {
        themeColorMeta.setAttribute('content', themeColor.color)
      }
    })

    return {
      query,
      openWait,
      openFailTips,
      routeToDownload,
      routeToFxRedpack,
      routeToDownloadLink,
      themeColor,
      shareButtonRef,
      copyHandler,
      toast,
      bg
    }
  }
})
